import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]
  static values = {
    urls: Array,
    interval: { type: Number, default: 300 }
  }

  connect() {
    this.currentIndex = 0
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (!this.hasUrlsValue || this.urlsValue.length < 2) return

    this.timer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.urlsValue.length
      this.imageTarget.src = this.urlsValue[this.currentIndex]
    }, this.intervalValue)
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.currentIndex = 0
    if (this.hasImageTarget && this.hasUrlsValue && this.urlsValue.length > 0) {
      this.imageTarget.src = this.urlsValue[0]
    }
  }
}
